export const Twitter = [
  {
    path: '/twitter/:app_module_id',
    name: 'twitter.index',
    component: () => import('@/pages/Twitter/TwitterModule')
  },
]
